"use strict";
/**
 * Created by yangpeng on 4/17/17.
 */
exports.__esModule = true;
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var metalog;
            (function (metalog) {
                var AdjustFittedPoints = /** @class */ (function () {
                    function AdjustFittedPoints() {
                    }
                    /**
                     * Get the probability of success data from failure branch stages
                     * probability. Sum the probability of failure of each stage then
                     * get the probability of success.
                     *
                     * @param failureBranchStages {Array<any>}
                     * @returns {number}
                     */
                    AdjustFittedPoints.probabilityOfSuccessFrom = function (failureBranchStages) {
                        var probabilityOfFailure = failureBranchStages.map(function (item) {
                            return item.probability;
                        }).reduce(function (acc, probability) {
                            return acc + probability;
                        });
                        return 1 - probabilityOfFailure;
                    };
                    /**
                     * Get the index of position to insert the stage into metalog data.
                     *
                     * @param adjustedCdf {Array<IndividualPoint>}
                     * @param stage {Stage}
                     * @returns {number}
                     */
                    AdjustFittedPoints.indexOfStageInCdf = function (adjustedCdf, stage) {
                        var matchedIndex = -1;
                        for (var i = 0; i < adjustedCdf.length && matchedIndex === -1; i++) {
                            if (i > 0 && adjustedCdf[i].x >= stage.value && stage.value > adjustedCdf[i - 1].x) {
                                matchedIndex = i;
                            }
                            else if (i == 0 && stage.value <= adjustedCdf[0].x) {
                                matchedIndex = 0;
                            }
                        }
                        if (matchedIndex === -1) {
                            matchedIndex = adjustedCdf.length;
                        }
                        return matchedIndex;
                    };
                    /**
                     * Mutiply probability of metalog to probability of success to get
                     * adjusted metalog data.
                     *
                     * @param cdfPointsFromSuccessCurve {Array<IndividualPoint>}
                     * @param probabilityOfSuccess {number}
                     * @returns {Array<IndividualPoint>}
                     */
                    AdjustFittedPoints.adjustCdfPoints = function (cdfPointsFromSuccessCurve, probabilityOfSuccess) {
                        return cdfPointsFromSuccessCurve.map(function (item) {
                            return { x: item.x, y: item.y * probabilityOfSuccess };
                        });
                    };
                    /**
                     * Insert stage into metalog data.
                     *
                     * @param adjustedCdf {Array<IndividualPoint>} output of adjustCdfPoints
                     * @param stage {Stage}
                     * @returns {Array<IndividualPoint>}
                     */
                    AdjustFittedPoints.insertIntoCdf = function (adjustedCdf, stage) {
                        var matchedIndex = AdjustFittedPoints.indexOfStageInCdf(adjustedCdf, stage);
                        var newCdf = adjustedCdf.map(function (item, index) {
                            return index >= matchedIndex ? {
                                x: item.x,
                                y: item.y + stage.probability
                            } : {
                                x: item.x,
                                y: item.y
                            };
                        });
                        // Insert the point into array.
                        var prevProbability = matchedIndex > 0 ? newCdf[matchedIndex - 1].y : 0;
                        newCdf.splice(matchedIndex, 0, {
                            x: stage.value,
                            y: prevProbability
                        });
                        newCdf.splice(matchedIndex + 1, 0, {
                            x: stage.value,
                            y: prevProbability + stage.probability
                        });
                        return newCdf;
                    };
                    AdjustFittedPoints.formatFittedPointsFrom = function (fittedpoints) {
                        return fittedpoints.map(function (item) {
                            return {
                                x: item[0],
                                y: item[1]
                            };
                        });
                    };
                    AdjustFittedPoints.fittedPointsFrom = function (formattedFittedPoints) {
                        return formattedFittedPoints.map(function (item) {
                            return [item.x, item.y];
                        });
                    };
                    /**
                     * Get adjusted metalog data based on given failure branch stages.
                     *
                     * @param cdfData {Array<IndividualPoint>}
                     * @param failureBranchStages {Array<Stage>}
                     * @returns {Array<IndividualPoint>}
                     */
                    AdjustFittedPoints.makeFailureBranchStagesData = function (cdfData, failureBranchStages) {
                        var adjustedCdf = AdjustFittedPoints.adjustCdfPoints(cdfData, AdjustFittedPoints.probabilityOfSuccessFrom(failureBranchStages));
                        failureBranchStages.sort(function (a, b) {
                            if (a.value < b.value) {
                                return -1;
                            }
                            if (a.value > b.value) {
                                return 1;
                            }
                            return 0;
                        });
                        failureBranchStages.forEach(function (stage) {
                            adjustedCdf = AdjustFittedPoints.insertIntoCdf(adjustedCdf, stage);
                        });
                        return adjustedCdf;
                    };
                    return AdjustFittedPoints;
                }());
                metalog.AdjustFittedPoints = AdjustFittedPoints;
            })(metalog = acts.metalog || (acts.metalog = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.acts.metalog;
//# sourceMappingURL=adjust-fitted-points.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/metalog/app/js/logic/adjust-fitted-points.js